//Acordion
class HdtAccordionGroup extends HTMLElement {
  connectedCallback() {
      this.querySelectorAll('.hdt-accordion').forEach(accordion => {
          accordion.querySelector('.hdt-acc-heading').addEventListener('click', () => {
              const isActive = accordion.classList.contains('active');
              const content = accordion.querySelector('.hdt-acc-content');

              if (isActive) {
                  accordion.classList.remove('active');
              } else {
                  accordion.classList.add('active');
              }
          });
      });
  }
}
customElements.define('hdt-accordion-group', HdtAccordionGroup);
// Button scroll
document.querySelector('.hdt-scroll-presets').addEventListener('click', (e) => {
  e.preventDefault();
  e.stopPropagation();
  document.querySelector('#hdt-section-presets').scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
});
//Slide banner
class HdtSliderBanner extends HTMLElement {
  constructor() {
      super();
      this.currentIndex = 0;
      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;
      this.autoPlayInterval = null;
  }

  connectedCallback() {
      this.track = this.querySelector('.hdt-slider-viewport');
      this.totalSlides = this.querySelectorAll('.hdt-banner-item').length;

      this.track.addEventListener('mousedown', e => this.dragStart(e));
      this.track.addEventListener('mousemove', e => this.dragMove(e));
      this.track.addEventListener('mouseup', e => this.dragEnd(e));
      this.track.addEventListener('mouseleave', e => this.dragEnd(e));

      this.track.addEventListener('touchstart', e => this.dragStart(e), { passive: true });
      this.track.addEventListener('touchmove', e => this.dragMove(e), { passive: true });
      this.track.addEventListener('touchend', e => this.dragEnd(e));

      this.startAutoPlay();
      this.addEventListener('mouseenter', () => this.stopAutoPlay());
      this.addEventListener('mouseleave', () => this.startAutoPlay());

      this.goTo(0);
  }

  goTo(index) {
    this.currentIndex = (index + this.totalSlides) % this.totalSlides;
    const slideWidth = this.offsetWidth;
    this.track.style.transform = `translateX(-${this.currentIndex * slideWidth}px)`;
  }

  next() { this.goTo(this.currentIndex + 1); }
  prev() { this.goTo(this.currentIndex - 1); }

  dragStart(e) {
      this.isDragging = true;
      this.startX = e.touches ? e.touches[0].clientX : e.clientX;
      this.track.style.transition = 'none';
  }

  dragMove(e) {
    if (!this.isDragging) return;
    this.currentX = (e.touches ? e.touches[0].clientX : e.clientX) - this.startX;
    const slideWidth = this.offsetWidth;
    this.track.style.transform = `translateX(${-this.currentIndex * slideWidth + this.currentX}px)`;
  }

  dragEnd(e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.style.transition = '';
      if (this.currentX < -50) this.next();
      else if (this.currentX > 50) this.prev();
      else this.goTo(this.currentIndex);
      this.currentX = 0;
  }

  startAutoPlay() {
      this.autoPlayInterval = setInterval(() => this.next(), 3000);
  }

  stopAutoPlay() {
      clearInterval(this.autoPlayInterval);
  }
}

customElements.define('hdt-slider-banner', HdtSliderBanner);
//Grap marquee
const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (prefersReduced) {
  document.querySelectorAll('.hdt-marquee-wrap').forEach(el => {
    let isDown = false, startX, scrollLeft;

    el.addEventListener('mousedown', e => {
      e.preventDefault();
      isDown = true;
      el.style.cursor = 'grabbing';
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    });

    ['mouseleave', 'mouseup'].forEach(evt => 
      el.addEventListener(evt, () => {
        isDown = false;
        el.style.cursor = 'grab';
      })
    );

    el.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const walk = (e.pageX - el.offsetLeft - startX) * 1.5;
      el.scrollLeft = scrollLeft - walk;
    });
  });
}
// Section sticky
document.addEventListener('DOMContentLoaded', function () {
  const triggerSection = document.querySelector('.hdt-show-section-sticky');
  const stickySection = document.querySelector('.hdt-section-sticky');

  if (!stickySection) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        const top = entry.boundingClientRect.top;
        const triggerPoint = window.innerHeight * 0.4;
  
        if (top <= triggerPoint) {
          stickySection.classList.add('is-sticky');
        } else {
          stickySection.classList.remove('is-sticky');
        }
      });
    },
    { threshold: Array.from({ length: 101 }, (_, i) => i / 100) }
  );

  observer.observe(triggerSection);
});
// Backtotop
document.querySelector('.hdt-backtotop').addEventListener('click', function () {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

// 
window.$crisp=[];
window.CRISP_WEBSITE_ID="f1c92d41-c7e9-441f-92c9-e85c2ca031e5";

(function(){
  d=document;
  s=d.createElement("script");
  s.src="https://client.crisp.chat/l.js";
  s.async=1;
  d.getElementsByTagName("head")[0].appendChild(s);
})();
$crisp.push(["on", "session:loaded", function() {
  console.log("✅ Chat session của Crisp đã được khởi tạo thành công!");
  document.querySelector('.hdt-section-sticky').classList.add('show-sticky');
}]);
document.addEventListener("click", function(e) {
  if (e.target.closest(".open-crisp")) {

      e.preventDefault();
      e.stopPropagation();
      const btn = e.target.closest(".open-crisp");
      const text_message = btn.dataset.message || "I would like to get support for The4's Shopify themes.";

      $crisp.push(["do", "chat:show"]);
      $crisp.push(["do", "chat:open"]);
      $crisp.push(["set", "message:text", [text_message]]);
  }
});